import React, { FC } from 'react';
import './styles.scss';

type NumberedStepProps = {
  step: number;
};

const NumberedSteps: FC<NumberedStepProps> = ({ step }) => {
  return (
    <div className='numbered-steps'>
      <div className='numbered-step w-[20%]'>
        <p className={`no ${step >= 1 ? 'no-active' : 'no-inactive'}`}>1</p>
        <div className={`grow h-[1px] ${step >= 1 ? 'no-active-dash' : 'no-inactive-dash'}`} />
      </div>
      <div className='numbered-step w-[30%]'>
        <div className={`w-[30%] h-[1px] ${step >= 2 ? 'no-active-dash' : 'no-inactive-dash'}`} />
        <p className={`no ${step >= 2 ? 'no-active' : 'no-inactive'}`}>2</p>
        <div className={`grow h-[1px] ${step >= 2 ? 'no-active-dash' : 'no-inactive-dash'}`} />
      </div>
      <div className='numbered-step w-[30%]'>
        <div className={`w-[30%] h-[1px] ${step >= 3 ? 'no-active-dash' : 'no-inactive-dash'}`} />
        <p className={`no ${step >= 3 ? 'no-active' : 'no-inactive'}`}>3</p>
        <div className={`grow h-[1px] ${step >= 3 ? 'no-active-dash' : 'no-inactive-dash'}`} />
      </div>
      <div className='numbered-step w-[20%]'>
        <div className={`grow h-[1px] ${step >= 4 ? 'no-active-dash' : 'no-inactive-dash'}`} />
        <p className={`no ${step >= 4 ? 'no-active' : 'no-inactive'}`}>4</p>
      </div>
    </div>
  );
};

export default NumberedSteps;
